import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import classnames from 'classnames';
import { map, groupBy, orderBy } from 'lodash';
import { Row, Col, Table, Button, Card } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import Navigation from '../../constants/enums/NavigationEnum'
import { MovementType, PersonalAccountMovements, MovementViewModel, AccrualViewModel } from '../../models/AccountModels';
import { AlarmEnum } from '../../models/GenericModels';
import { Settings } from '../../constants/settings';

import { ApplicationState } from '../../store';
import * as AccountStore from '../../store/AccountStore';
import DataString from '../components/DataString';
import moment from 'moment';

const tableHeaders = [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь",
    "За год",
]

type ServicesDetailsProps =
    AccountStore.AccountStateState &
    RouteComponentProps<{}>;


class ServicesDetailsPage extends React.PureComponent<ServicesDetailsProps> {


    constructor(props: ServicesDetailsProps) {
        super(props);
    }

    async componentDidMount() {

    }

    componentWillUnmount(): void {

    }


    private GetAccrualType(kind: string): MovementType {
        if (kind?.toLowerCase() === 'приход') {
            return MovementType.Arrival;
        }
        else if (kind?.toLowerCase() === 'расход') {
            return MovementType.Spending;
        }
        else {
            return MovementType.None;
        }
    }


    private GetAccrualTitle(kind: string): string {
        if (kind?.toLowerCase() === 'приход') {
            return "Начислено";
        }
        else if (kind?.toLowerCase() === 'расход') {
            return "Оплачено";
        }
        else {
            return "--";
        }
    }


    private GetStatusColor(status: string): string {
        switch (status) {
            case "Активна": return "#28a745";
            case "Завершена": return "rgba(44, 59, 72, 0.80)";
            default: return "";
        }
    }

    private TransformAcctuas(movements: PersonalAccountMovements[]): MovementViewModel[] {
        let result = map(groupBy(movements, item => item.year), (item, key) => {
            let movement: MovementViewModel = {
                year: Number.parseInt(key),
                accruals: map(item, subItem => {
                    let accrual: AccrualViewModel = {
                        type: this.GetAccrualType(subItem.kind),
                        kind: this.GetAccrualTitle(subItem.kind),
                        year: subItem.year,
                        values: [
                            subItem.january,
                            subItem.february,
                            subItem.march,
                            subItem.april,
                            subItem.may,
                            subItem.june,
                            subItem.jule,
                            subItem.august,
                            subItem.september,
                            subItem.october,
                            subItem.november,
                            subItem.december,
                            subItem.allYear]

                    }
                    return accrual;
                })
            }
            if (!movement.accruals.find(e => e.type === MovementType.Spending) || !movement.accruals.find(e => e.type === MovementType.Arrival)) {
                let currentAc = movement.accruals[0];
                let type = currentAc.type === MovementType.Arrival ? MovementType.Spending : MovementType.Arrival
                let kind = currentAc.kind === "Начислено" ? "Оплачено" : "Начислено"
                movement.accruals.push(
                    {
                        type: type,
                        kind: kind,
                        year: currentAc.year,
                        values: new Array<number>(13).fill(0)
                    }
                )
            }
            return movement;
        })
        return result;

    }


    render(): React.ReactNode {
        let account = this.props.accounts[this.props.selectedAccount]

        return (<React.Fragment>

            <div className='details'>
                <div className='details__card details__account '>
                    <div className='details__account_balance_string--header'>
                        <div className='name-passive--8'>Лицевой счет:</div>
                        <div className='value-text--bold'>{account === undefined ? "" : account.balance.personalAccount}</div>
                    </div>

                    <div className='details__account_balance_string_wrapper'>
                        <div className='details__account_balance_string'>
                            <div className='name-passive--8'>Текущий баланс:</div>
                            <div className={`${account !== undefined && account.balance.balanceCurrent >= 0 ? "balance-text--green" : "balance-text--red"}`}>{account === undefined ? "0" : account.balance.balanceCurrent} ₽</div>
                        </div>
                        <div className='details__account_balance_string'>
                            <div className='name-passive--8'>Баланс на квартал:</div>
                            <div className={`${account !== undefined && account.balance.balanceKvartal >= 0 ? "balance-text--green" : "balance-text--red"}`}>{account === undefined ? "0" : account.balance.balanceKvartal} ₽</div>
                        </div>
                        <div className='details__account_balance_string'>
                            <div className='name-passive--8'>Баланс на год:</div>
                            <div className={`${account !== undefined && account.balance.balanceYear >= 0 ? "balance-text--green" : "balance-text--red"}`}>{account === undefined ? "0" : account.balance.balanceYear} ₽</div>
                        </div>
                    </div>
                    <div className=' press-bottom'></div>
                    <a className='details__account_balance_to-pay button button-text very-big' href={account !== undefined ? `${Settings.PayCyfralServiceSite}Orders/${account.balance.personalAccount}` : ""}>
                        Оплатить
                    </a>
                    <div className='devider--horizontal'></div>
                    <div className='name-passive--6'>{account !== undefined && account.balance.address}</div>
                </div>

                <div className='details__card details__services'>
                    <div className='text-bold'>Услуги</div>
                    <div className='details__services_wrapper'>
                        {account === undefined ? <div className='name-passive--8'>Не выбран лицевой счет</div> :
                            account.services.length === 0 ?
                                <div className='name-passive--8'>На данном лицевом счете нет услуг.</div>
                                : account.services.map((element, index) => {
                                    return <React.Fragment key={index}>
                                        <div className='details__services_service_wrapper'>
                                            <div className='value-text--bold'>{element.serviceFullName}</div>
                                            <div className='details__services_service'>
                                                <DataString title='Статус' value={element.status} valueColor={this.GetStatusColor(element.status)} />
                                                <DataString title='Дата начала' value={moment(element.dateStart).format("DD.MM.yyyy")} />
                                                <DataString title='Тариф' value={element.price + " ₽/мес"} />
                                                <DataString title='Скидка' value={element.discount} />
                                                <DataString title='Кол-во' value={element.volume} />
                                                <DataString title='Начислено' value={element.amount + " ₽"} />

                                            </div>
                                        </div>
                                        {index !== account.services.length - 1 && <div className='devider--horizontal' />}


                                    </React.Fragment>
                                })}
                    </div>
                </div>

                <div className='details__card details__movments'>
                    <div className='text-bold'>История начислений и оплат</div>
                    {account === undefined ? <div className='name-passive--8'>Не выбран лицевой счет</div> :
                        account.balance.movements.length === 0 ?
                            <div className='name-passive--8'>На данном лицевом счете нет начислений и оплат.</div>
                            : <div className='details__movments_wrapper'>
                                <div className='details__movments_header'>
                                    <div />
                                    {tableHeaders.map((element, index) => {
                                        return <div className='table-header' key={index}>{element}</div>
                                    })}
                                </div>
                                <div className='details__movments_content'>
                                    {orderBy(this.TransformAcctuas(account.balance.movements), (e) => e.year, "desc").map((element, index) => {
                                        return <div className='details__movments_content_year-data' key={index}>
                                            <div className='details__movments_content_year-data_year name-passive--8'>{element.year}</div>
                                            <div className='details__movments_content_year-data_data'>
                                                {map(orderBy(element.accruals, subItem => subItem.type), (subElement, subKey) =>

                                                    <div className='details__movments_content_year-data_data_row' key={subKey}>
                                                        <div className='table-header'>{subElement.kind}</div>
                                                        {tableHeaders.map((headElement, headIndex) => {
                                                            return <div className='details__movments_content_year-data_data_row_wrapper' key={headIndex}>
                                                                <div className='details__movments_content_year-data_data_row_dummy table-header' key={headIndex}>{headElement}</div>
                                                                <div className='details__movments_content_year-data_data_row_value text-med'>{subElement.values[headIndex]}</div>
                                                            </div>
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </div>}
                </div>
            </div>
        </React.Fragment>)
    }
}



export default connect(
    (state: ApplicationState) => state.AccountState,
    null
)(ServicesDetailsPage as any);
